import { z } from 'zod'

export const ProtocolDataTypeSchema = z.object({
  app_role: z.string(),
  livechat_app_id: z.string().nullable(),
})
